import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "components/yenimahalle/Layout";
import ContentText from "components/yenimahalle/ContentText";
import AlbumImages from "components/yenimahalle/AlbumImages";
import PortalApi from "../../api/PortalApi";
import { Project, ProjectDetailResponse } from "../../models/Response/Portal";
import tw from "twin.macro";
import { slugify } from "utils/slugify";
import RoutingSidebar from "components/yenimahalle/RoutingSidebar";
import BasicHeader from "components/yenimahalle/BasicHeader";
import styled from "styled-components";

interface OtherProjectsItem {
  id: number;
  title: string;
  imageSrc: string;
}
// Styled Components
const NewsContentContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
`;

const LeftColumn = tw.div`w-full lg:w-9/12 px-5`;
const RightColumn = tw.div`w-full lg:w-3/12 mt-8 lg:mt-0`;

const Card = styled.a`
  ${tw`
    flex flex-col h-full w-full 
    sm:border sm:rounded-tl-4xl sm:rounded-br-5xl 
    relative focus:outline-none
    bg-primary-200 text-black
    cursor-default
  `}
`;

const CardImage = styled.img`
  ${tw`
    w-full 
    rounded-tl-4xl 
    sm:rounded-none 
    sm:rounded-tl-4xl 
    rounded-br-4xl 
    object-cover 
    mx-auto 
    block
  `}
  height: auto;
  max-height: 400px;
`;

const Heading = tw.span`
  inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

const ProjeDetay: React.FC = () => {
  const { projectName, projectID } = useParams<{ projectName: string; projectID: string }>();
  const [project, setProject] = useState<ProjectDetailResponse | null>(null);
  const [otherProjects, setotherProjects] = useState<OtherProjectsItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await PortalApi.getProjectDetail(Number(projectID));
        if (response) {
          setProject(response);
          if (response.otherProjects) {
            const mappedData = response.otherProjects.map((item: Project) => ({
              id: item.projectId,
              title: item.projectName,
              imageSrc: item.projectMainImage,
            }));
            setotherProjects(mappedData);
          }
        }
      } catch (error) {
        console.error("Proje Detay alınırken hata:", error);
      }
    };
    fetchData();
  }, [projectID]);

  const handleCardClick = (item: OtherProjectsItem) => {
    const url = `/ProjeDetay/${slugify(item.title)}/${item.id}`;
    navigate(url);
    window.scrollTo({ top: 100, behavior: "smooth" });
  };

  if (!project) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <Layout>
      <BasicHeader headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe" headingLine2="" />

      <NewsContentContainer>
        <LeftColumn>
          <Heading>{project.projectName}</Heading>
          <Card href={"#"}>
            <CardImage src={project.projectMainImage} />
          </Card>
          <ContentText htmlContent={project.projectDetail} />

          {project.projectImagesList.length > 0 && (
            <>
              <Heading>Foto Galeri</Heading>
              <AlbumImages images={project.projectImagesList} />
            </>
          )}
        </LeftColumn>

        <RightColumn>
          <RoutingSidebar heading="Diğer Projeler" cards={otherProjects} onItemClick={handleCardClick} />
        </RightColumn>
      </NewsContentContainer>
    </Layout>
  );
};

export default ProjeDetay;
